import React from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { AiAssistedSearchBanner } from '@thd-olt-component-react/ai-assisted-search-banner';

export const IN_GRID_COMPONENT_REGISTRY = {
  aiAssistedSearchBanner: () => (
    <ErrorBoundary name="ai-assisted-search-banner">
      <AiAssistedSearchBanner />
    </ErrorBoundary>
  )
};
